import { Component, OnInit, ViewChild } from '@angular/core';
import { MeasurementStandardService } from '../../services/measurement-standard.service';
import { MeasurementStandard } from '../../models/measurement-standard';
import { MatTableDataSource, MatSort, MatDialog } from '@angular/material';
import { RequestSelectorComponent } from '../request-selector/request-selector.component';
import { MeasurementRequest } from '../../models/measurement-request';
import { Router } from '@angular/router';

@Component({
  selector: 'app-measurement-standard-list',
  templateUrl: './measurement-standard-list.component.html',
  styleUrls: ['./measurement-standard-list.component.css']
})
export class MeasurementStandardListComponent implements OnInit {

  public displayedColumns = ['actions', 'requestCode', 'customerName'];
  public dataSource: MatTableDataSource<MeasurementStandard>;
  private sort: any;
  constructor(
    private measurementStandardService: MeasurementStandardService,
    public dialog: MatDialog,
    private router: Router
    ) {

    }

  @ViewChild(MatSort, {static: false}) matSort: MatSort;

  ngOnInit() {
    this.getAll();
  }
  public getAll = () => {
    this.measurementStandardService.GetAll()
    .subscribe(res => {
      this.dataSource =  new MatTableDataSource<MeasurementStandard>(res.payload);
    });
  }
  onAdd() {
    const dialogRef = this.dialog.open(RequestSelectorComponent, {
      width: '80vw'
    });

    dialogRef.afterClosed().subscribe((result: MeasurementRequest) => {
      if (result) {
        const create: MeasurementStandard = new MeasurementStandard();
        create.code = result.code;
        create.name = result.name;
        create.requestCode = result.customerCode;
        create.customerName = result.account;
        create.requestId = result.id;
        this.measurementStandardService.Create(create).subscribe((res) => {
          if (res && res.payload) {
            this.onEdit(res.payload);
          }
        });
      }
    });
  }
  onDelete(item: MeasurementStandard) {}
  onEdit(item: MeasurementStandard) {
    this.router.navigate(['/plasard-measurement/standard/edit', item.id]);
  }
}
